"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _iconConstants = require("./iconConstants");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(_ref) {
  var name = _ref.name,
      disabled = _ref.disabled,
      _ref$tiny = _ref.tiny,
      tiny = _ref$tiny === void 0 ? true : _ref$tiny,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      xlarge = _ref.xlarge,
      color = _ref.color,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["name", "disabled", "tiny", "small", "medium", "large", "xlarge", "color", "onClick"]);

  var allowedModifiers = {
    disabled: disabled,
    tiny: tiny && !small && !medium && !large && !xlarge,
    small: small,
    medium: medium,
    large: large,
    xlarge: xlarge
  };

  var iconClasses = _defineProperty({
    'co-icon': true
  }, color, color);

  return _react.default.createElement(_styler.default, {
    classNames: iconClasses,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("i", _extends({
      className: styles,
      onClick: onClick,
      disabled: disabled,
      "aria-hidden": "true",
      "data-co-icon": name
    }, (0, _getNativeProps.default)(props)), name);
  });
};

Object.keys(_iconConstants.ICON_NAMES).forEach(function (key) {
  Icon[_iconConstants.ICON_NAMES[key].toUpperCase()] = _iconConstants.ICON_NAMES[key];
});
var exclusiveSizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('tiny', 'small', 'medium', 'large', 'xlarge');
Icon.propTypes = {
  name: (0, _propTypes.oneOf)(Object.values(_iconConstants.ICON_NAMES)),
  color: (0, _propTypes.oneOf)(_iconConstants.COLOR_VALUES),
  tiny: exclusiveSizeProps,
  small: exclusiveSizeProps,
  medium: exclusiveSizeProps,
  large: exclusiveSizeProps,
  xlarge: exclusiveSizeProps,
  disabled: _propTypes.bool,
  onClick: _propTypes.func
};
var _default = Icon;
exports.default = _default;
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "tiny": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "exclusiveSizeProps"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.values(ICON_NAMES)"
      },
      "required": false,
      "description": ""
    },
    "color": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "COLOR_VALUES"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizeProps"
      },
      "required": false,
      "description": ""
    },
    "medium": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizeProps"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizeProps"
      },
      "required": false,
      "description": ""
    },
    "xlarge": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizeProps"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};